import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import MissingFiles from '../../_common/Draw/MissingFiles';

type NoInventoryProps = {
  seasonId?: string;
  episodeId?: string;
  type?: string;
};

const NoInventory = ({ seasonId, episodeId, type }: NoInventoryProps) => {
  return (
    <Grid container flexDirection="column" alignItems="center" justifyContent="center" sx={{ p: 4, pt: 6, pb: 6 }}>
      <MissingFiles style={{ maxHeight: 200, width: '100%' }} />
      <Typography variant="h6" sx={{ mt: 5 }}>
        No inventory found for
        <Box sx={{ display: 'inline', color: type === 'version' ? 'tertiary.main' : 'primary.main' }}>
          {' '}
          {type ? type : episodeId ? 'episode' : seasonId ? 'season' : 'title'}
        </Box>
        .
      </Typography>
    </Grid>
  );
};

export default NoInventory;
